import React from 'react';
import './styles.css';

export interface GroupedContentProps<T> {
  groups: Record<string, T[]>;
  renderGroup: (groupName: string, items: T[]) => React.ReactNode;
  groupTitle?: (groupName: string) => React.ReactNode;
  emptyMessage?: string;
  className?: string;
}

/**
 * A component for displaying grouped content with consistent styling for group headers.
 * Unlike GroupedCards, this component gives full control over how each group's content is rendered.
 */
const GroupedContent = <T extends unknown>({
  groups,
  renderGroup,
  groupTitle = (name) => name,
  emptyMessage = 'No items found.',
  className = ''
}: GroupedContentProps<T>) => {
  const groupEntries = Object.entries(groups);

  if (groupEntries.length === 0) {
    return (
      <div className="grouped-content-empty">
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={`grouped-content ${className}`}>
      {groupEntries.map(([groupName, items]) => (
        <div key={groupName} className="grouped-content-section">
          <h3 className="grouped-content-title">{groupTitle(groupName)}</h3>
          <div className="grouped-content-body">
            {renderGroup(groupName, items)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GroupedContent; 